// AUTO-GENERATED — do not edit by hand.
// Re-generate by running: node scripts/parse-dap27.js
// Source: data/sources/dap27.xlsx
// Generated: 2026-03-30T03:35:57.557Z

import { FinancialData } from '../types/FinancialData';

export const dap27Data: FinancialData = {
  "title": "Hutt City Council — Draft Annual Plan 2026/27",
  "description": "183 capital projects across 11 activity areas. Total DAP 2027 spend: $96M. Click a category to explore projects, or click a project for the 10-year forecast.",
  "years": [
    "2025/2026",
    "2026/2027",
    "2027/2028",
    "2028/2029",
    "2029/2030",
    "2030/2031",
    "2031/2032",
    "2032/2033",
    "2033/2034"
  ],
  "categories": [
    {
      "id": "water-supply",
      "name": "Water Supply",
      "color": "#2563eb"
    },
    {
      "id": "wastewater",
      "name": "Wastewater",
      "color": "#8b5cf6"
    },
    {
      "id": "stormwater",
      "name": "Stormwater",
      "color": "#0891b2"
    },
    {
      "id": "solid-waste",
      "name": "Solid Waste",
      "color": "#059669"
    },
    {
      "id": "sustainability-resilience",
      "name": "Sustainability & Resilience",
      "color": "#65a30d"
    },
    {
      "id": "transport",
      "name": "Transport",
      "color": "#d97706"
    },
    {
      "id": "city-development",
      "name": "City Development",
      "color": "#ef4444"
    },
    {
      "id": "community-partnering-support",
      "name": "Community Partnering & Support",
      "color": "#ec4899"
    },
    {
      "id": "open-spaces-parks-reserves",
      "name": "Open Spaces, Parks, & Reserves",
      "color": "#16a34a"
    },
    {
      "id": "connectivity-creativity-learning-recreation",
      "name": "Connectivity, Creativity, Learning, & Recreation",
      "color": "#a855f7"
    },
    {
      "id": "corporate-services",
      "name": "Corporate Services",
      "color": "#64748b"
    }
  ],
  "budgetItems": [
    {
      "id": "capex-water-supply-001",
      "name": "Network Upgrades WS Growth",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 335334,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-water-supply-002",
      "name": "Reservoir Upgrades WS Growth",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 1543382,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-water-supply-003",
      "name": "Distribution Pipe Model Development",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 173052,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-water-supply-004",
      "name": "Network Upgrade WS",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 2921914,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-water-supply-005",
      "name": "Reservoir Upgrades WS",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 19787,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-water-supply-006",
      "name": "Water Resilience",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 500000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-water-supply-007",
      "name": "Reactive Network Renewals WS",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 2970000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-water-supply-008",
      "name": "Reactive Pump Station Renewals",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 356400,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-water-supply-009",
      "name": "Reactive Reservoir Renewals",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 99000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-water-supply-010",
      "name": "Control Systems Renewals WS",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 29700,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-water-supply-011",
      "name": "Network Renewals WS",
      "category": "water-supply",
      "yearlyAmounts": {
        "2025/2026": 16326179,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-012",
      "name": "Network Upgrades WW Growth",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 456087,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-wastewater-013",
      "name": "Wastewater Valley Floor Infrastructure Growth",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 5470000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-wastewater-014",
      "name": "Wastewater Storage JV Project",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 664361,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-wastewater-015",
      "name": "Network Upgrades WW",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 2606169,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-wastewater-016",
      "name": "Trunk Main Outfall Pipeline Overflow Mitigation",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 300000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-wastewater-017",
      "name": "Joint Venture Trunk Reticulation DBO network Cyclic Upgrade",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 1682560,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-wastewater-018",
      "name": "Wastewater Modelling",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 31350,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-019",
      "name": "Network Renewals WW",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 9989126,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-020",
      "name": "Pump Station Upgrades WW",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 990000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-021",
      "name": "Trunk DBO JV asset replacement and Capacity upgrade",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 28010083,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-022",
      "name": "Trunk DBO Network Cyclic Replacement",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 5621000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-023",
      "name": "Joint Venture trunk reticulation DBO network cyclic replmnt",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 187272,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-wastewater-024",
      "name": "Seaview WWTP JV sludge Handling Renewal and Capacity Upgrade",
      "category": "wastewater",
      "yearlyAmounts": {
        "2025/2026": 36635498,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-stormwater-025",
      "name": "Stormwater development Projects",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 1648667,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-stormwater-026",
      "name": "Network Upgrades SW Growth",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 494081,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-stormwater-027",
      "name": "Stormwater Valley Floor Infrastructure Growth",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 5670000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-stormwater-028",
      "name": "Network Upgrades SW",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 55650,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-stormwater-029",
      "name": "Stormwater consenting project",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 266757,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-stormwater-030",
      "name": "Stormwater Network Modelling",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 403310,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-stormwater-031",
      "name": "Control Systems renewals SW",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 9900,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-stormwater-032",
      "name": "Network Renewals SW",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 970365,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-stormwater-033",
      "name": "Pump Station Reactive Renewals SW",
      "category": "stormwater",
      "yearlyAmounts": {
        "2025/2026": 933744,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-solid-waste-034",
      "name": "Silverstream Landfill Stage 2",
      "category": "solid-waste",
      "description": "The Silverstream Landfill is the main refuse disposal site for the Hutt Valley. Stage 2 covers design and construction of additional landfill capacity to extend the site's operational lifespan. This capital project ensures the city continues to have compliant, long-term solid waste disposal infrastructure.",
      "yearlyAmounts": {
        "2025/2026": 15355666,
        "2026/2027": 6325388,
        "2027/2028": 7249152,
        "2028/2029": 6054766,
        "2029/2030": 4477405,
        "2030/2031": 5753551,
        "2031/2032": 5815025,
        "2032/2033": 641579,
        "2033/2034": 776169
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-solid-waste-035",
      "name": "Silverstream Landfill Asbestos Cell",
      "category": "solid-waste",
      "description": "A dedicated containment cell at the Silverstream Landfill for the safe disposal of asbestos-containing materials. Asbestos waste requires special handling and segregated storage to meet regulatory requirements under the Health and Safety at Work Act. This cell ensures HCC can continue to accept and safely manage asbestos from demolition and renovation projects across the district.",
      "yearlyAmounts": {
        "2025/2026": 39906,
        "2026/2027": 3087985,
        "2027/2028": 0,
        "2028/2029": 2284075,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 1168849,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-solid-waste-036",
      "name": "Silverstream Landfill Transfer Station",
      "category": "solid-waste",
      "description": "A transfer station at the Silverstream Landfill site allows waste collected from across the Hutt Valley to be consolidated and transferred efficiently for disposal. This project covers capital improvements to the transfer station infrastructure. Upgrades support the safe and efficient movement of solid waste through the council's waste management system.",
      "yearlyAmounts": {
        "2025/2026": 517000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-solid-waste-037",
      "name": "Food and Green Waste",
      "category": "solid-waste",
      "description": "Hutt City Council operates food and green waste collection services to divert organic material from landfill. This project funds capital investment in infrastructure and equipment to support food and organic waste processing. Diverting organic waste reduces landfill use and contributes to the council's sustainability and emissions reduction goals.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 8783230,
        "2028/2029": 5154758,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-sustainability-resilience-038",
      "name": "105 Western Hutt Road ERT Facility",
      "category": "sustainability-resilience",
      "description": "The Emergency Response Team (ERT) facility at 105 Western Hutt Road provides a fit-for-purpose base for the council's civil emergency response operations. The building includes a training room, office space, and gear storage for team members during emergency operations and training events. It also supports wider civil defence functions for Hutt City. The project experienced delays with resource consent and construction timelines.",
      "yearlyAmounts": {
        "2025/2026": 256000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-046",
      "name": "Subdivisions Road Improvements",
      "category": "transport",
      "description": "Capital works to improve roads within new residential subdivisions, ensuring they meet council standards before being vested in the public network. This covers upgrades to road geometry, surfacing, footpaths, and drainage in developing areas. Investment in subdivision roading supports growth and ensures new residents have access to quality transport infrastructure.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 3765408,
        "2028/2029": 3848144,
        "2029/2030": 3929041,
        "2030/2031": 4011409,
        "2031/2032": 4091939,
        "2032/2033": 4173572,
        "2033/2034": 4252999
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-transport-047",
      "name": "Cross Valley Connections",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 1110000,
        "2027/2028": 3600000,
        "2028/2029": 4100000,
        "2029/2030": 5000000,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "description": "Cross Valley Connections is a new road corridor linking Moera and Waiwhetu to State Highway 2 on the eastern side of Wellington Harbour, providing an alternative route for residents in these lower Hutt suburbs. The project improves cross-valley connectivity and resilience, reducing reliance on existing routes through the city centre and along Petone Esplanade. Merged from two budget lines: Cross Valley Connections ($1.06M, Improve Level of Service, 95.2%) and Cross Valley Connections — Growth ($0.05M, Meet Additional Demand, 4.8%). Figures show combined 2026/27 total of $1.11M.",
      "subcategories": [
        {
          "id": "capex-transport-047",
          "name": "Cross Valley Connections",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 1056311,
            "2027/2028": 3429717,
            "2028/2029": 3905098,
            "2029/2030": 4739864,
            "2030/2031": 0,
            "2031/2032": 0,
            "2032/2033": 0,
            "2033/2034": 0
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-039",
          "name": "Cross Valley Connections — Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 53689,
            "2027/2028": 170283,
            "2028/2029": 194902,
            "2029/2030": 260136,
            "2030/2031": 0,
            "2031/2032": 0,
            "2032/2033": 0,
            "2033/2034": 0
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-048",
      "name": "Reconstruction Improvements",
      "category": "transport",
      "description": "Targeted reconstruction of road sections that have deteriorated beyond what routine maintenance or resurfacing can remedy. Reconstruction involves removing and replacing the pavement base as well as the wearing course. This ensures long-term structural integrity of the road network and reduces ongoing maintenance costs in problem areas.",
      "yearlyAmounts": {
        "2025/2026": 88992,
        "2026/2027": 91306,
        "2027/2028": 93497,
        "2028/2029": 95552,
        "2029/2030": 97561,
        "2030/2031": 99606,
        "2031/2032": 101605,
        "2032/2033": 103632,
        "2033/2034": 105605
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-049",
      "name": "Broadband Ducting",
      "category": "transport",
      "description": "Installation of conduit ducts beneath road surfaces during planned roading works to enable future fibre broadband cables to be laid without reopening roads. This \"dig once\" approach avoids costly repeated excavation and saves ratepayers money in the long run. The work is typically carried out alongside other capital road projects where disruption is already occurring.",
      "yearlyAmounts": {
        "2025/2026": 23361,
        "2026/2027": 23968,
        "2027/2028": 24543,
        "2028/2029": 25082,
        "2029/2030": 25610,
        "2030/2031": 26147,
        "2031/2032": 26671,
        "2032/2033": 27204,
        "2033/2034": 27721
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-050",
      "name": "Land Purchase For Roads",
      "category": "transport",
      "description": "Acquisition of land required for planned road improvements, widening, or new roading projects across the district. Land purchase is often a necessary precursor to transport infrastructure investment, particularly for larger projects. Securing land in advance enables construction to proceed when funding and planning conditions are met.",
      "yearlyAmounts": {
        "2025/2026": 11124,
        "2026/2027": 11435,
        "2027/2028": 11710,
        "2028/2029": 11967,
        "2029/2030": 12219,
        "2030/2031": 12475,
        "2031/2032": 12725,
        "2032/2033": 12979,
        "2033/2034": 13226
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-051",
      "name": "Substandard Roads Upgrade",
      "category": "transport",
      "description": "Upgrade of roads in the network that do not meet current design standards, including carriageway width, horizontal or vertical alignment, and drainage. Many of these are older rural or hillside roads that predate modern standards. Upgrades improve safety and accessibility for residents, particularly in outlying areas of the district.",
      "yearlyAmounts": {
        "2025/2026": 621473,
        "2026/2027": 320195,
        "2027/2028": 327879,
        "2028/2029": 335084,
        "2029/2030": 342128,
        "2030/2031": 349300,
        "2031/2032": 704614,
        "2032/2033": 718671,
        "2033/2034": 732348
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-052",
      "name": "Cycling Micromobility Programme",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 6279368,
        "2026/2027": 0,
        "2027/2028": 3976658,
        "2028/2029": 9762433,
        "2029/2030": 8558156,
        "2030/2031": 10848604,
        "2031/2032": 6847009,
        "2032/2033": 6853189,
        "2033/2034": 6859183
      },
      "projectType": "capex",
      "description": "An ongoing programme investing in cycling and micromobility infrastructure across the district, including new cycle lanes, shared paths, bike parking, and safety improvements at intersections. The programme aims to make cycling and other forms of active transport a safe and attractive choice for more residents. Combined from: Cycling Micromobility Programme ($56.52M 8-yr total, Improve Level of Service) and Cycling Micro-mobility Programme Growth ($3.46M 8-yr total, Meet Additional Demand). No spending in 2026/27; Long-Term Plan forecasts only.",
      "subcategories": [
        {
          "id": "capex-transport-052",
          "name": "Cycling Micromobility Programme",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 6041000,
            "2026/2027": 0,
            "2027/2028": 3738058,
            "2028/2029": 9176687,
            "2029/2030": 8044666,
            "2030/2031": 10197688,
            "2031/2032": 6436188,
            "2032/2033": 6441998,
            "2033/2034": 6447632
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-040",
          "name": "Cycling Micro-mobility Programme Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 238368,
            "2026/2027": 0,
            "2027/2028": 238600,
            "2028/2029": 585746,
            "2029/2030": 513490,
            "2030/2031": 650916,
            "2031/2032": 410821,
            "2032/2033": 411191,
            "2033/2034": 411551
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-053",
      "name": "Tupua Horo Nuku Eastern Bays",
      "category": "transport",
      "description": "Tupua Horo Nuku is a shared walking and cycling path along the Eastern Bays coastline, connecting communities from Petone to Pencarrow. The project received Government shovel-ready funding through Waka Kotahi NZTA and is delivering a safe, scenic off-road route along the eastern shore of Wellington Harbour. This project funds the council's contribution to the next stages of the coastal path.",
      "yearlyAmounts": {
        "2025/2026": 17261000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-054",
      "name": "Traffic Safety Improvements",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 3121075,
        "2026/2027": 2610915,
        "2027/2028": 1170996,
        "2028/2029": 1196727,
        "2029/2030": 1221885,
        "2030/2031": 1247500,
        "2031/2032": 1272544,
        "2032/2033": 1297931,
        "2033/2034": 1322632
      },
      "projectType": "capex",
      "description": "A programme of targeted safety improvements at high-risk locations across the road network, including intersection upgrades, improved signage, lighting, and geometric improvements to reduce crash risk. Projects are prioritised based on crash data and safety assessments across the district. Combined from: Traffic Safety Improvements ($2.61M in 2026/27, 100.0%, Improve Level of Service) and Traffic Safety Improvements Growth ($0.00M in 2026/27, 0.0%, Meet Additional Demand). Total 2026/27: $2.61M.",
      "subcategories": [
        {
          "id": "capex-transport-054",
          "name": "Traffic Safety Improvements",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 3121075,
            "2026/2027": 2610915,
            "2027/2028": 1147576,
            "2028/2029": 1172792,
            "2029/2030": 1197447,
            "2030/2031": 1222550,
            "2031/2032": 1247093,
            "2032/2033": 1271972,
            "2033/2034": 1296179
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-042",
          "name": "Traffic Safety Improvements Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 23420,
            "2028/2029": 23935,
            "2029/2030": 24438,
            "2030/2031": 24950,
            "2031/2032": 25451,
            "2032/2033": 25959,
            "2033/2034": 26453
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-055",
      "name": "Local Area Traffic Management",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 117100,
        "2028/2029": 119672,
        "2029/2030": 122189,
        "2030/2031": 124750,
        "2031/2032": 127254,
        "2032/2033": 129793,
        "2033/2034": 132263
      },
      "projectType": "capex",
      "description": "Local area traffic management (LATM) involves installing physical measures such as speed humps, raised platforms, chicanes, and traffic islands to manage vehicle speeds and volumes in residential streets. These measures make streets safer and more pleasant for pedestrians and cyclists, particularly around schools and community facilities. Combined from: Local Area Traffic Management ($0.86M 8-yr total, Improve Level of Service) and Local Area Traffic Management Growth ($0.02M 8-yr total, Meet Additional Demand). No spending in 2026/27; Long-Term Plan forecasts only.",
      "subcategories": [
        {
          "id": "capex-transport-055",
          "name": "Local Area Traffic Management",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 114758,
            "2028/2029": 117279,
            "2029/2030": 119745,
            "2030/2031": 122255,
            "2031/2032": 124709,
            "2032/2033": 127197,
            "2033/2034": 129618
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-043",
          "name": "Local Area Traffic Management Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 2342,
            "2028/2029": 2393,
            "2029/2030": 2444,
            "2030/2031": 2495,
            "2031/2032": 2545,
            "2032/2033": 2596,
            "2033/2034": 2645
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-057",
      "name": "Road Network Improvements",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 858540,
        "2026/2027": 967053,
        "2027/2028": 946042,
        "2028/2029": 963355,
        "2029/2030": 960010,
        "2030/2031": 960810,
        "2031/2032": 1073865,
        "2032/2033": 1095288,
        "2033/2034": 1116132
      },
      "projectType": "capex",
      "description": "A programme of improvements to the road network including geometry upgrades, intersection improvements, and carriageway widening where roads are identified as not fit-for-purpose for current or future traffic demands. Projects are selected based on engineering assessments and network performance data. Combined from: Road Network Improvements ($0.84M in 2026/27, 86.9%, Improve Level of Service) and Road Network Improvements - Growth ($0.13M in 2026/27, 13.1%, Meet Additional Demand). Total 2026/27: $0.97M.",
      "subcategories": [
        {
          "id": "capex-transport-057",
          "name": "Road Network Improvements",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 706262,
            "2026/2027": 840271,
            "2027/2028": 811096,
            "2028/2029": 792193,
            "2029/2030": 795282,
            "2030/2031": 791354,
            "2031/2032": 846212,
            "2032/2033": 863093,
            "2033/2034": 879519
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-045",
          "name": "Road Network Improvements - Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 152278,
            "2026/2027": 126782,
            "2027/2028": 134946,
            "2028/2029": 171162,
            "2029/2030": 164728,
            "2030/2031": 169456,
            "2031/2032": 227653,
            "2032/2033": 232195,
            "2033/2034": 236613
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-058",
      "name": "Bridge Seismic Strengthening Cuba St. Overbridge",
      "category": "transport",
      "description": "Structural works to improve the earthquake resilience of the Cuba Street Overbridge, which carries Cuba Street over a rail line in central Lower Hutt. The overbridge was assessed as needing seismic strengthening to meet current New Zealand standards. The works ensure this key urban link remains safe and operational during and after a seismic event.",
      "yearlyAmounts": {
        "2025/2026": 671000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-059",
      "name": "Network Resilience - Eastern Hutt Road",
      "category": "transport",
      "description": "Eastern Hutt Road runs north from Stokes Valley to Silverstream and is a critical route for communities in the upper Hutt Valley. The road is vulnerable to damage from the river bank below and the hillside above, requiring significant works on both the riverbank and the slope to prevent slips and erosion from undermining the carriageway. This project funds resilience improvements to protect this key arterial and keep it open following severe weather or seismic events.",
      "yearlyAmounts": {
        "2025/2026": 2097518,
        "2026/2027": 14342342,
        "2027/2028": 4108734,
        "2028/2029": 9002143,
        "2029/2030": 7262395,
        "2030/2031": 3229013,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-060",
      "name": "Pay & Display Extension - New",
      "category": "transport",
      "description": "Extension of the pay and display parking system to new locations within the Lower Hutt CBD, increasing the footprint of metered parking in the city centre. Pay and display encourages turnover of parking spaces and supports access for shoppers and businesses. This project covers the purchase and installation of new machines and associated infrastructure at identified CBD sites.",
      "yearlyAmounts": {
        "2025/2026": 430000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-061",
      "name": "Ava Pedestrian Bridge",
      "category": "transport",
      "description": "Construction of a new pedestrian and cycling bridge alongside the existing Ava Rail Bridge, providing a safe off-road crossing of the Hutt River near Ava train station. The project is delivered in partnership with KiwiRail, utilising the rail bridge structure to support the new walkway. The bridge improves active travel connections between communities on both sides of the river and to the station.",
      "yearlyAmounts": {
        "2025/2026": 3000000,
        "2026/2027": 2400000,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-062",
      "name": "Speed Limit Reversal",
      "category": "transport",
      "description": "Reinstatement of original speed limits on roads where reductions had been put in place, following the New Zealand Government's direction to review lower speed limits. This involves changes to signage and road markings to reflect updated speed limit settings. The project supports the government's programme of reversing speed limit reductions on suitable roads.",
      "yearlyAmounts": {
        "2025/2026": 252000,
        "2026/2027": 100000,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-transport-063",
      "name": "Area Wide Pavement Treatment",
      "category": "transport",
      "description": "Systematic surface treatment of road pavements across defined geographic areas of the network, rather than addressing individual roads in isolation. This approach is more cost-effective and reduces disruption compared to responding to isolated failures. It is part of the council's planned maintenance programme to extend the life of the existing road network.",
      "yearlyAmounts": {
        "2025/2026": 4540722,
        "2026/2027": 4691885,
        "2027/2028": 8187898,
        "2028/2029": 8367808,
        "2029/2030": 8541818,
        "2030/2031": 8720889,
        "2031/2032": 8899799,
        "2032/2033": 9077348,
        "2033/2034": 9250097
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-064",
      "name": "Pavement Surfacing",
      "category": "transport",
      "description": "Annual programme of resurfacing roads across the district, applying a new wearing course to extend pavement life and restore skid resistance. Regular resurfacing is the most cost-effective way to maintain road surfaces and is critical to road safety. The programme is prioritised based on condition assessments and traffic volumes.",
      "yearlyAmounts": {
        "2025/2026": 3877471,
        "2026/2027": 4007979,
        "2027/2028": 2944794,
        "2028/2029": 3009499,
        "2029/2030": 3077282,
        "2030/2031": 3140823,
        "2031/2032": 3203505,
        "2032/2033": 3267414,
        "2033/2034": 3329596
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-065",
      "name": "Footpath Resurfacing And Replacement",
      "category": "transport",
      "description": "Renewal and replacement of deteriorated footpaths across the district to maintain safe pedestrian access. Cracked or sunken footpaths are a trip hazard, particularly for older residents and those with mobility impairments. This programme is prioritised based on condition inspections and customer requests.",
      "yearlyAmounts": {
        "2025/2026": 1955366,
        "2026/2027": 2010442,
        "2027/2028": 480108,
        "2028/2029": 490658,
        "2029/2030": 500973,
        "2030/2031": 511475,
        "2031/2032": 521743,
        "2032/2033": 532151,
        "2033/2034": 542279
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-066",
      "name": "Minor Road And Footpath Construction",
      "category": "transport",
      "description": "Construction of small sections of new road or footpath to fill gaps in the transport network or improve access. These are typically lower-cost projects that respond to local community requests for improved connectivity. Examples include extending footpaths to connect missing links or improving access at bus stops.",
      "yearlyAmounts": {
        "2025/2026": 82318,
        "2026/2027": 84458,
        "2027/2028": 86485,
        "2028/2029": 88385,
        "2029/2030": 90244,
        "2030/2031": 92135,
        "2031/2032": 93985,
        "2032/2033": 95860,
        "2033/2034": 97684
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-067",
      "name": "Road Reconstruction",
      "category": "transport",
      "description": "Full-depth reconstruction of road sections that have structurally failed and cannot be remedied by resurfacing alone. Reconstruction involves removing existing pavement layers and rebuilding from the subbase up. It is targeted at roads where the underlying structure has been compromised, often due to poor drainage or inadequate original construction.",
      "yearlyAmounts": {
        "2025/2026": 258162,
        "2026/2027": 264944,
        "2027/2028": 351299,
        "2028/2029": 359018,
        "2029/2030": 366565,
        "2030/2031": 374250,
        "2031/2032": 381763,
        "2032/2033": 389379,
        "2033/2034": 396789
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-068",
      "name": "Wainuiomata Hill Rd Safety Seal",
      "category": "transport",
      "description": "Resealing of Wainuiomata Hill Road to improve safety on this winding, heavily trafficked route connecting Wainuiomata with the wider Hutt Valley. Safety sealing restores skid resistance and addresses surface defects on a road that sees significant wear from traffic and weather. This reduces the risk of accidents, particularly in wet conditions.",
      "yearlyAmounts": {
        "2025/2026": 630599,
        "2026/2027": 647167,
        "2027/2028": 810181,
        "2028/2029": 827983,
        "2029/2030": 845389,
        "2030/2031": 863112,
        "2031/2032": 880439,
        "2032/2033": 898003,
        "2033/2034": 915093
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-069",
      "name": "Traffic Signal Replacement",
      "category": "transport",
      "description": "Replacement of ageing traffic signal equipment across the district, including controllers, detector loops, signal heads, and associated infrastructure. Traffic signals are critical safety infrastructure, and ageing equipment is more prone to failure. This programme ensures the network operates reliably and reduces the risk of signal malfunctions causing accidents or congestion.",
      "yearlyAmounts": {
        "2025/2026": 188810,
        "2026/2027": 193771,
        "2027/2028": 199069,
        "2028/2029": 203443,
        "2029/2030": 207720,
        "2030/2031": 212075,
        "2031/2032": 216332,
        "2032/2033": 220648,
        "2033/2034": 224847
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-070",
      "name": "Minor Safety Works",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 59721,
        "2028/2029": 61033,
        "2029/2030": 62316,
        "2030/2031": 63622,
        "2031/2032": 64899,
        "2032/2033": 66194,
        "2033/2034": 67455
      },
      "projectType": "capex",
      "description": "Small-scale safety improvements across the road network, such as guardrail installation, improved road markings, delineation, and minor intersection works that address identified safety risks at a lower cost than major capital projects. The programme allows the council to respond quickly to safety concerns raised by the community or identified through inspections. Combined from: Minor Safety Works ($0.44M 8-yr total, Replace Existing Assets) and Minor Safety Works Growth ($0.01M 8-yr total, Meet Additional Demand). No spending in 2026/27; Long-Term Plan forecasts only.",
      "subcategories": [
        {
          "id": "capex-transport-070",
          "name": "Minor Safety Works",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 58526,
            "2028/2029": 59812,
            "2029/2030": 61069,
            "2030/2031": 62349,
            "2031/2032": 63601,
            "2032/2033": 64870,
            "2033/2034": 66105
          },
          "projectType": "capex",
          "subcategoryTag": "replace-existing-assets"
        },
        {
          "id": "capex-transport-041",
          "name": "Minor Safety Works Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 1195,
            "2028/2029": 1221,
            "2029/2030": 1247,
            "2030/2031": 1273,
            "2031/2032": 1298,
            "2032/2033": 1324,
            "2033/2034": 1350
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-071",
      "name": "Pedestrian Crossings",
      "category": "transport",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 67334,
        "2028/2029": 68814,
        "2029/2030": 70260,
        "2030/2031": 71733,
        "2031/2032": 73173,
        "2032/2033": 74633,
        "2033/2034": 76053
      },
      "projectType": "capex",
      "description": "Installation of new pedestrian crossings and renewal of existing crossing facilities across the district, including zebra crossings, raised crossings, and signalised crossings. Safe crossing points are critical infrastructure for pedestrians, particularly near schools, shops, and community facilities. Combined from: Pedestrian Crossing Renewal ($0.27M 8-yr total, Replace Existing Assets) and Pedestrian Crossings - New ($0.23M 8-yr total, Improve Level of Service) and Pedestrian Crossing New Growth ($0.00M 8-yr total, Meet Additional Demand). No spending in 2026/27; Long-Term Plan forecasts only.",
      "subcategories": [
        {
          "id": "capex-transport-071",
          "name": "Pedestrian Crossing Renewal",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 36301,
            "2028/2029": 37099,
            "2029/2030": 37878,
            "2030/2031": 38672,
            "2031/2032": 39449,
            "2032/2033": 40236,
            "2033/2034": 41002
          },
          "projectType": "capex",
          "subcategoryTag": "replace-existing-assets"
        },
        {
          "id": "capex-transport-056",
          "name": "Pedestrian Crossings - New",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 30413,
            "2028/2029": 31081,
            "2029/2030": 31735,
            "2030/2031": 32400,
            "2031/2032": 33050,
            "2032/2033": 33710,
            "2033/2034": 34351
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-transport-044",
          "name": "Pedestrian Crossing New Growth",
          "category": "transport",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 0,
            "2027/2028": 620,
            "2028/2029": 634,
            "2029/2030": 647,
            "2030/2031": 661,
            "2031/2032": 674,
            "2032/2033": 687,
            "2033/2034": 700
          },
          "projectType": "capex",
          "subcategoryTag": "meet-additional-demand"
        }
      ]
    },
    {
      "id": "capex-transport-072",
      "name": "Streetlight Lantern Replacement Programme",
      "category": "transport",
      "description": "Systematic replacement of older streetlight lanterns with modern LED technology across the district. LED streetlights use significantly less energy than older sodium or metal halide lanterns, reducing both operating costs and carbon emissions. The programme brings lighting levels up to current standards while extending the life of existing poles.",
      "yearlyAmounts": {
        "2025/2026": 261714,
        "2026/2027": 268512,
        "2027/2028": 276225,
        "2028/2029": 280909,
        "2029/2030": 286337,
        "2030/2031": 290332,
        "2031/2032": 254509,
        "2032/2033": 259586,
        "2033/2034": 264526
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-073",
      "name": "Streetlight Standard Replacement",
      "category": "transport",
      "description": "Replacement of streetlight poles (standards) that have reached the end of their serviceable life or failed structural assessments. Older poles made from timber or early steel can corrode or become structurally unsound, posing a safety risk. This programme ensures the streetlight network remains structurally sound across the district.",
      "yearlyAmounts": {
        "2025/2026": 327144,
        "2026/2027": 335643,
        "2027/2028": 345284,
        "2028/2029": 351138,
        "2029/2030": 357923,
        "2030/2031": 362915,
        "2031/2032": 318136,
        "2032/2033": 324483,
        "2033/2034": 330658
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-074",
      "name": "Carpark Resurfacing",
      "category": "transport",
      "description": "Resurfacing of council-owned carparks across the district to maintain safe, durable surfaces. Carpark surfaces deteriorate over time from vehicle traffic, weather, and UV exposure. Regular resurfacing extends the asset life and ensures safe, well-presented access for the public.",
      "yearlyAmounts": {
        "2025/2026": 56733,
        "2026/2027": 58321,
        "2027/2028": 59721,
        "2028/2029": 61033,
        "2029/2030": 62316,
        "2030/2031": 63623,
        "2031/2032": 64900,
        "2032/2033": 66195,
        "2033/2034": 67454
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-075",
      "name": "Bridge Renewals - Norton Park Ave / Nelson Cres",
      "category": "transport",
      "description": "Structural renewal works on bridges at Norton Park Avenue and Nelson Crescent, which carry road traffic over waterways in Lower Hutt. These bridges have been assessed as needing renewal to extend their operational life and ensure they continue to meet loading requirements. Works may include deck replacement, bearing renewal, and corrosion treatment.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 1112447,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-076",
      "name": "Estuary Bridge Corrosion Protection",
      "category": "transport",
      "description": "Application of protective coatings and corrosion treatment to bridge structures exposed to the estuary environment, where tidal and saltwater conditions accelerate deterioration. The Hutt River estuary bridges are particularly vulnerable to corrosion. This project extends the life of these assets and avoids premature replacement.",
      "yearlyAmounts": {
        "2025/2026": 1066796,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-077",
      "name": "Pay & Display Extension",
      "category": "transport",
      "description": "Ongoing extension and renewal of pay and display parking within the Lower Hutt CBD, including replacement of ageing machines and expansion to additional city centre locations. Pay and display systems manage parking demand in busy areas, encouraging turnover and supporting retail and commercial activity. This project covers rollout and renewal of parking technology in the central city.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 195979,
        "2027/2028": 351299,
        "2028/2029": 205092,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 226669
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-transport-078",
      "name": "Transport Resilience Projects",
      "category": "transport",
      "description": "A programme of projects to improve the resilience of transport infrastructure across the Hutt Valley against natural hazard events such as earthquakes and flooding. The Hutt Valley's geography makes transport corridors vulnerable to slips, inundation, and other disruptions. Projects may include slope stabilisation, culvert upgrades, and flood protection measures on key routes.",
      "yearlyAmounts": {
        "2025/2026": 2501375,
        "2026/2027": 1378934,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-city-development-079",
      "name": "Urban Growth Strategy Improvements",
      "category": "city-development",
      "description": "Capital investment to support implementation of Hutt City's Urban Growth Strategy, guiding the location and form of future development across the district. Projects may include infrastructure to enable intensification in identified growth areas, or public realm improvements in town centres. The strategy aims to accommodate housing growth in a sustainable, well-connected way.",
      "yearlyAmounts": {
        "2025/2026": 1539000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-city-development-080",
      "name": "Petone 2040",
      "category": "city-development",
      "description": "Capital works to support the Petone 2040 strategy, which sets a long-term vision for the development and revitalisation of Petone. Petone is identified as a key destination and growth area with a rich industrial heritage and excellent public transport access. Projects under this programme include public realm improvements, streetscape upgrades, and enabling infrastructure for intensification.",
      "yearlyAmounts": {
        "2025/2026": 430000,
        "2026/2027": 228710,
        "2027/2028": 234199,
        "2028/2029": 239345,
        "2029/2030": 244377,
        "2030/2031": 249500,
        "2031/2032": 254509,
        "2032/2033": 259586,
        "2033/2034": 264526
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-city-development-081",
      "name": "Naenae Town Centre Improvements",
      "category": "city-development",
      "description": "Public realm and infrastructure improvements in Naenae town centre as part of the broader Naenae regeneration programme. Following the closure of the original Naenae Pool, the council committed to major reinvestment in the suburb, including the new pool and fitness centre and improvements to the main street. These works aim to revitalise the area for shoppers, residents, and businesses.",
      "yearlyAmounts": {
        "2025/2026": 640000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-city-development-082",
      "name": "RiverLink",
      "category": "city-development",
      "description": "Te Wai Takamori o Te Awa Kairangi, also known as RiverLink, is a major flood protection and urban development project at the heart of Lower Hutt city. The project involves raising stopbanks along the Hutt River, developing new riverside public spaces, and improving connections between the city centre and the waterfront. It is a partnership between Hutt City Council, Greater Wellington Regional Council, and Waka Kotahi NZTA.",
      "yearlyAmounts": {
        "2025/2026": 11079666,
        "2026/2027": 15647948,
        "2027/2028": 32261025,
        "2028/2029": 31622823,
        "2029/2030": 39888546,
        "2030/2031": 35259426,
        "2031/2032": 16669194,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-community-partnering-support-083",
      "name": "Walter Nash Centre Equipment and Fitout",
      "category": "community-partnering-support",
      "description": "Purchase and installation of new equipment and furnishings at the Walter Nash Centre in Taita, a major multi-sport community facility. The centre hosts a wide range of sporting codes and community activities. Equipment investment ensures the facility remains fit-for-purpose and continues to attract sports clubs and community groups.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 105390,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-community-partnering-support-084",
      "name": "Community Hubs - Building Improvements",
      "category": "community-partnering-support",
      "description": "Capital improvements to community hub buildings across the district to maintain and enhance their functionality and condition. Community hubs serve as gathering places for local residents and host a range of health, social, and recreational services. Investment in the physical facilities ensures they remain welcoming and fit-for-purpose.",
      "yearlyAmounts": {
        "2025/2026": 5562,
        "2026/2027": 5718,
        "2027/2028": 5855,
        "2028/2029": 5984,
        "2029/2030": 6109,
        "2030/2031": 6237,
        "2031/2032": 6363,
        "2032/2033": 6490,
        "2033/2034": 6613
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-community-partnering-support-085",
      "name": "Decarbonisation Energy Conversion",
      "category": "community-partnering-support",
      "description": "Conversion of building energy systems in community facilities from fossil fuels to low-carbon alternatives, typically switching from gas to electric heating and hot water. This project is part of the council's programme to reduce carbon emissions from its own buildings. Switching to electricity reduces reliance on gas and improves the council's environmental performance.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 490655,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-community-partnering-support-086",
      "name": "Community Houses",
      "category": "community-partnering-support",
      "description": "Capital investment in council-owned community houses across the district to maintain, improve, or expand these facilities. Community houses provide affordable venues for community organisations, support groups, and neighbourhood activities. This funding ensures the buildings remain structurally sound and fit for community use.",
      "yearlyAmounts": {
        "2025/2026": 55620,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 60069,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 63874,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-community-partnering-support-087",
      "name": "Belmont Memorial Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal works on the Belmont Memorial Hall to extend its operational life and maintain its function as a community venue in the Belmont suburb. Memorial halls are important community assets, hosting events, gatherings, and regular hirer activities. Renewal works typically address building fabric, services, and accessibility improvements.",
      "yearlyAmounts": {
        "2025/2026": 22762,
        "2026/2027": 6417,
        "2027/2028": 67502,
        "2028/2029": 810,
        "2029/2030": 134329,
        "2030/2031": 0,
        "2031/2032": 52552,
        "2032/2033": 0,
        "2033/2034": 14375
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-088",
      "name": "Eastbourne Hall Renewal",
      "category": "community-partnering-support",
      "description": "Structural and building fabric renewal of the Eastbourne Hall, a key community venue serving the Eastbourne and Days Bay communities. The hall is used for events, meetings, and regular community activities on the eastern side of Wellington Harbour. Renewal ensures the building remains safe and functional for these communities.",
      "yearlyAmounts": {
        "2025/2026": 66186,
        "2026/2027": 33666,
        "2027/2028": 98433,
        "2028/2029": 2181,
        "2029/2030": 127016,
        "2030/2031": 3713,
        "2031/2032": 213826,
        "2032/2033": 0,
        "2033/2034": 45454
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-089",
      "name": "Epuni Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Epuni Hall to address building condition issues and extend the asset's useful life. The hall serves the Epuni community in Lower Hutt as a venue for local organisations and events. Renewal works ensure it continues to provide a safe and welcoming community space.",
      "yearlyAmounts": {
        "2025/2026": 54095,
        "2026/2027": 24068,
        "2027/2028": 30937,
        "2028/2029": 811,
        "2029/2030": 139413,
        "2030/2031": 0,
        "2031/2032": 24591,
        "2032/2033": 0,
        "2033/2034": 26698
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-090",
      "name": "Wainuiomata Memorial Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal works on the Wainuiomata Memorial Hall, an important community facility at the heart of the Wainuiomata valley. The hall hosts community events, cultural gatherings, and regular local activities. This investment maintains the building in a condition appropriate for its role as a hub for the Wainuiomata community.",
      "yearlyAmounts": {
        "2025/2026": 33241,
        "2026/2027": 10315,
        "2027/2028": 46873,
        "2028/2029": 7988,
        "2029/2030": 91311,
        "2030/2031": 8112,
        "2031/2032": 57607,
        "2032/2033": 6427,
        "2033/2034": 10945
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-091",
      "name": "Maungaraki Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Maungaraki Hall to address building condition issues and maintain its role as a community facility in this western hills suburb. The hall serves as a venue for local gatherings, community groups, and events. Renewal works extend the building's operational life and ensure it remains fit for use.",
      "yearlyAmounts": {
        "2025/2026": 89875,
        "2026/2027": 204073,
        "2027/2028": 29445,
        "2028/2029": 0,
        "2029/2030": 404171,
        "2030/2031": 103343,
        "2031/2032": 1824,
        "2032/2033": 0,
        "2033/2034": 37362
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-092",
      "name": "Walter Nash Centre Renewal",
      "category": "community-partnering-support",
      "description": "Major renewal works on the Walter Nash Centre in Taita to address building condition issues across this large multi-sport community facility. The centre houses multiple sports courts, fitness facilities, and community spaces. Renewal investment ensures the centre remains a viable, high-quality venue for sporting codes and community groups.",
      "yearlyAmounts": {
        "2025/2026": 183987,
        "2026/2027": 219887,
        "2027/2028": 526405,
        "2028/2029": 616,
        "2029/2030": 1088723,
        "2030/2031": 569197,
        "2031/2032": 258546,
        "2032/2033": 0,
        "2033/2034": 254321
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-093",
      "name": "Stokes Valley Hub Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Stokes Valley Community Hub building to maintain and improve its condition and functionality. Community hubs provide a central gathering place for local residents and host health, social, and community services. Renewal ensures the hub remains a welcoming and well-maintained facility for the Stokes Valley community.",
      "yearlyAmounts": {
        "2025/2026": 73083,
        "2026/2027": 66831,
        "2027/2028": 228213,
        "2028/2029": 14468,
        "2029/2030": 285254,
        "2030/2031": 1832,
        "2031/2032": 146460,
        "2032/2033": 4769,
        "2033/2034": 46643
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-094",
      "name": "Wainuiomata Hub Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Wainuiomata Community Hub to address building condition issues and extend the facility's operational life. The hub is a focal point for community services and activities in Wainuiomata. This investment maintains the building in a condition that supports its important community function.",
      "yearlyAmounts": {
        "2025/2026": 76034,
        "2026/2027": 57750,
        "2027/2028": 318718,
        "2028/2029": 3457,
        "2029/2030": 250883,
        "2030/2031": 1350,
        "2031/2032": 118606,
        "2032/2033": 688,
        "2033/2034": 77667
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-095",
      "name": "Community Hubs - Furniture & Equipment Replacements",
      "category": "community-partnering-support",
      "description": "Replacement of furniture and equipment in community hub facilities across the district as items reach the end of their serviceable life. This includes seating, tables, kitchen equipment, and audiovisual systems. Regular replacement maintains the quality and functionality of these shared community spaces.",
      "yearlyAmounts": {
        "2025/2026": 5006,
        "2026/2027": 5146,
        "2027/2028": 5270,
        "2028/2029": 365801,
        "2029/2030": 5499,
        "2030/2031": 5614,
        "2031/2032": 5727,
        "2032/2033": 5841,
        "2033/2034": 5952
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-096",
      "name": "CCTV Replacement",
      "category": "community-partnering-support",
      "description": "Replacement of ageing CCTV cameras and associated infrastructure in council community facilities. CCTV systems are important for public safety and the security of council assets. Modern replacement cameras provide higher image quality and improved reliability compared to older systems.",
      "yearlyAmounts": {
        "2025/2026": 156026,
        "2026/2027": 34307,
        "2027/2028": 35130,
        "2028/2029": 35902,
        "2029/2030": 48875,
        "2030/2031": 37425,
        "2031/2032": 38176,
        "2032/2033": 38938,
        "2033/2034": 132263
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-097",
      "name": "Community Houses Building Renewal",
      "category": "community-partnering-support",
      "description": "Structural and building fabric renewals across the council's portfolio of community houses. Community houses host a range of neighbourhood activities and support services. This funding addresses building condition issues to ensure the facilities remain safe and operational.",
      "yearlyAmounts": {
        "2025/2026": 181992,
        "2026/2027": 120000,
        "2027/2028": 260000,
        "2028/2029": 29072,
        "2029/2030": 280000,
        "2030/2031": 11541,
        "2031/2032": 100000,
        "2032/2033": 12163,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-098",
      "name": "Moera Community Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Moera Community Hall to address building condition issues and extend the asset life of this Lower Hutt community facility. The hall serves as a gathering place for the Moera and surrounding communities. Renewal works ensure it continues to be a safe and functional community space.",
      "yearlyAmounts": {
        "2025/2026": 107635,
        "2026/2027": 8141,
        "2027/2028": 88427,
        "2028/2029": 0,
        "2029/2030": 52319,
        "2030/2031": 41585,
        "2031/2032": 3496,
        "2032/2033": 0,
        "2033/2034": 26976
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-099",
      "name": "Treadwell Community Hall Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Treadwell Community Hall, addressing building condition to maintain its role as a community venue. The facility serves the local neighbourhood for regular hirers and community events. Renewal investment protects this community asset for continued use.",
      "yearlyAmounts": {
        "2025/2026": 54443,
        "2026/2027": 48536,
        "2027/2028": 30394,
        "2028/2029": 24341,
        "2029/2030": 26085,
        "2030/2031": 18677,
        "2031/2032": 11294,
        "2032/2033": 8682,
        "2033/2034": 27062
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-100",
      "name": "Hardwick-Smith Lounge Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the Hardwick-Smith Lounge, a community facility in the Belmont Domain. The lounge serves the local community as a meeting and social venue. Renewal works address building condition issues and extend the facility's operational life.",
      "yearlyAmounts": {
        "2025/2026": 16767,
        "2026/2027": 208513,
        "2027/2028": 19072,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-community-partnering-support-101",
      "name": "Hutt Art Society Renewal",
      "category": "community-partnering-support",
      "description": "Renewal of the building occupied by the Hutt Art Society, a long-standing creative community organisation. The society provides studio space, exhibition facilities, and art programmes for local residents. This renewal investment maintains the building fabric and ensures the facility can continue to support arts activity in the community.",
      "yearlyAmounts": {
        "2025/2026": 58686,
        "2026/2027": 60602,
        "2027/2028": 91151,
        "2028/2029": 8543,
        "2029/2030": 211392,
        "2030/2031": 36082,
        "2031/2032": 1824,
        "2032/2033": 0,
        "2033/2034": 30380
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-102",
      "name": "Reserve Developments",
      "category": "open-spaces-parks-reserves",
      "description": "A programme of capital improvements across reserves and open spaces throughout the district. Projects may include new recreational facilities, landscaping, playground installations, and improved amenities at various reserve locations. This ongoing programme ensures the city's green spaces continue to meet community needs.",
      "yearlyAmounts": {
        "2025/2026": 2599500,
        "2026/2027": 1927899,
        "2027/2028": 8186035,
        "2028/2029": 4704737,
        "2029/2030": 2719802,
        "2030/2031": 1676328,
        "2031/2032": 444749,
        "2032/2033": 50000,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-open-spaces-parks-reserves-103",
      "name": "Black Creek reserve development",
      "category": "open-spaces-parks-reserves",
      "description": "Development of the Black Creek Reserve, providing new recreational facilities and amenities for the local community. Black Creek flows through suburban Lower Hutt, and the reserve along its margins offers potential for walking paths, native planting, and ecological restoration alongside recreational use. This project invests in improving the reserve for both people and the environment.",
      "yearlyAmounts": {
        "2025/2026": 150000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "meet-additional-demand"
    },
    {
      "id": "capex-open-spaces-parks-reserves-104",
      "name": "Parks & Gardens Protection Bollards",
      "category": "open-spaces-parks-reserves",
      "description": "Installation of bollards in parks and gardens across the district to prevent vehicle access onto grassed areas, garden beds, and reserves. Vehicle incursions cause damage to turf and plantings, and bollards protect these assets while maintaining the quality of green spaces for park users.",
      "yearlyAmounts": {
        "2025/2026": 10220,
        "2026/2027": 10506,
        "2027/2028": 10758,
        "2028/2029": 10995,
        "2029/2030": 12348,
        "2030/2031": 13753,
        "2031/2032": 14030,
        "2032/2033": 14309,
        "2033/2034": 15797
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-105",
      "name": "Avalon Park Development",
      "category": "open-spaces-parks-reserves",
      "description": "Capital improvements to Avalon Park, a major open space in Lower Hutt that includes sports fields, a heritage rose garden, and recreational facilities. The park serves a wide catchment of residents and is a popular destination for families and community events. Development projects improve facilities and the experience for visitors.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 118127,
        "2027/2028": 0,
        "2028/2029": 1430457,
        "2029/2030": 0,
        "2030/2031": 141521,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-106",
      "name": "Car Park Development",
      "category": "open-spaces-parks-reserves",
      "description": "Construction or improvement of car parking facilities at parks and reserves across the district. Well-maintained carparks improve accessibility to open spaces, particularly for those with mobility needs or families with young children. This project funds new and improved carpark infrastructure at high-use reserve locations.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 247441,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 140972,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-107",
      "name": "Jubilee Park Drainage",
      "category": "open-spaces-parks-reserves",
      "description": "Drainage improvements at Jubilee Park to address waterlogging and improve the usability of sports fields and open space. Poor drainage affects the quality of playing surfaces and limits the hours fields can be used each year. Better drainage extends the useful life of turf surfaces and improves the park experience for all users.",
      "yearlyAmounts": {
        "2025/2026": 40880,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-108",
      "name": "New Tracks & Track Upgrades",
      "category": "open-spaces-parks-reserves",
      "description": "Construction of new walking and mountain biking tracks and upgrades to existing tracks in the district's reserves and hill country. Tracks provide opportunities for recreation and active travel in the natural environment. Investment in new and improved tracks expands the recreational network and ensures existing routes are safe and accessible.",
      "yearlyAmounts": {
        "2025/2026": 111398,
        "2026/2027": 0,
        "2027/2028": 123721,
        "2028/2029": 0,
        "2029/2030": 134710,
        "2030/2031": 0,
        "2031/2032": 146141,
        "2032/2033": 0,
        "2033/2034": 243028
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-109",
      "name": "Percy Reserve SH2 Development",
      "category": "open-spaces-parks-reserves",
      "description": "Development of recreational facilities and amenities within Percy Reserve, which sits in the Western Hills alongside State Highway 2. The reserve offers walking tracks and access to the urban-rural fringe of Lower Hutt. This project improves visitor access, signage, and amenities to better serve those using the reserve.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 21094,
        "2027/2028": 0,
        "2028/2029": 130242,
        "2029/2030": 0,
        "2030/2031": 141521,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-110",
      "name": "Valley Floor Review Implementation",
      "category": "open-spaces-parks-reserves",
      "description": "Delivery of projects identified in the Valley Floor Review, which examined reserves and open spaces across the floor of the Hutt Valley. The review focused on smaller neighbourhood reserves and connections between them, with projects including pathway improvements, pedestrian bridges, planting, and amenity upgrades. Works are spread across reserves throughout the valley floor.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 650107,
        "2029/2030": 678425,
        "2030/2031": 0,
        "2031/2032": 733547,
        "2032/2033": 0,
        "2033/2034": 784377
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-111",
      "name": "Mountain Bike Park",
      "category": "open-spaces-parks-reserves",
      "description": "Development and maintenance of mountain biking infrastructure in the hills above Lower Hutt, supporting the growing sport of off-road cycling. The Hutt Valley hills provide excellent terrain for mountain bike trails, and this project funds the construction of new trails and associated facilities such as carparks and signage. Mountain biking is both a popular recreational activity and a growing tourism drawcard for the region.",
      "yearlyAmounts": {
        "2025/2026": 57232,
        "2026/2027": 60936,
        "2027/2028": 63474,
        "2028/2029": 65968,
        "2029/2030": 68478,
        "2030/2031": 71059,
        "2031/2032": 74490,
        "2032/2033": 77509,
        "2033/2034": 80547
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-112",
      "name": "Minoh Friendship House Improvements",
      "category": "open-spaces-parks-reserves",
      "description": "Improvements to the Minoh Friendship House, a facility that commemorates Lower Hutt's sister city relationship with Minoh, Japan. The building is located in a park setting and serves as a cultural symbol of the two cities' longstanding friendship. Capital improvements maintain the building's condition and presentation as a cultural landmark.",
      "yearlyAmounts": {
        "2025/2026": 38444,
        "2026/2027": 13466,
        "2027/2028": 74384,
        "2028/2029": 693,
        "2029/2030": 40534,
        "2030/2031": 0,
        "2031/2032": 58687,
        "2032/2033": 0,
        "2033/2034": 29725
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-113",
      "name": "Toilets Upgrade",
      "category": "open-spaces-parks-reserves",
      "description": "Upgrade of public toilet facilities in parks and reserves across the district. Public toilets are important park infrastructure and a significant factor in the quality of the visitor experience. Upgrades address condition issues and improve the standard and accessibility of facilities at key reserve locations.",
      "yearlyAmounts": {
        "2025/2026": 850000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-114",
      "name": "Naenae Park Changing Rooms",
      "category": "open-spaces-parks-reserves",
      "description": "Construction of new or improved changing room facilities at Naenae Park to support sports and recreational use. Quality changing rooms are a key requirement for sports codes and encourage greater use of playing fields. This project improves the facilities available to sports clubs and other users of Naenae Park.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 1354210,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-115",
      "name": "Sportsville Artificial Playing Surface",
      "category": "open-spaces-parks-reserves",
      "description": "Installation of an artificial playing surface at a sportsville facility, providing a high-quality, all-weather field for sports clubs. Artificial surfaces can be used for more hours per year than natural grass and require less ongoing maintenance in the long run. This investment supports the council's sportsville model of co-locating sports clubs and sharing facilities.",
      "yearlyAmounts": {
        "2025/2026": 970900,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 2595370,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 2928478,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-116",
      "name": "Memorial Park Synthetic Turf & Changing Rooms",
      "category": "open-spaces-parks-reserves",
      "description": "Installation of synthetic turf and new changing room facilities at Memorial Park, one of Lower Hutt's key sports venues. A synthetic surface significantly extends the number of hours per year the field can be used and supports multiple sports codes. The changing rooms improve the experience for participants and enable greater use of the facility.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 280551,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-117",
      "name": "New Cemetery Development, Akatarawa Road",
      "category": "open-spaces-parks-reserves",
      "description": "Development of a new burial area at the Akatarawa Road cemetery to extend the capacity of the district's cemetery network. As existing cemetery space becomes limited, developing new sections is essential to ensure residents continue to have access to burial options. This project funds earthworks, drainage, roading, and landscaping to open new burial plots.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 1304576,
        "2028/2029": 0,
        "2029/2030": 3374276,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-118",
      "name": "Decarbonisation Energy Conversion (Parks)",
      "category": "open-spaces-parks-reserves",
      "description": "Conversion of energy systems in parks buildings and recreation facilities from fossil fuels to lower-carbon alternatives. This includes switching away from gas heating in changing rooms, pavilions, and maintenance sheds. The project contributes to the council's emissions reduction targets and reduces operating costs over time.",
      "yearlyAmounts": {
        "2025/2026": 440171,
        "2026/2027": 114800,
        "2027/2028": 0,
        "2028/2029": 120138,
        "2029/2030": 275235,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-119",
      "name": "Taita Cemetery Improvements",
      "category": "open-spaces-parks-reserves",
      "description": "Capital improvements to the Taita Cemetery to maintain and upgrade facilities for visitors and staff. Works may include path and access improvements, landscaping, and signage. A well-maintained cemetery is an important part of the district's community infrastructure and reflects respect for the community's memorial spaces.",
      "yearlyAmounts": {
        "2025/2026": 51100,
        "2026/2027": 580087,
        "2027/2028": 0,
        "2028/2029": 44150,
        "2029/2030": 518398,
        "2030/2031": 0,
        "2031/2032": 58684,
        "2032/2033": 598545,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-120",
      "name": "Percy Scenic Reserve Boardwalk",
      "category": "open-spaces-parks-reserves",
      "description": "Construction of a boardwalk through Percy Scenic Reserve in the Western Hills, providing safe and accessible access through this area. The boardwalk protects the natural environment by keeping walkers on a defined path away from sensitive vegetation. It improves the visitor experience and makes the reserve accessible to a wider range of people.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 137112,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-121",
      "name": "Wainuiomata Garden of Remembrance Improvement",
      "category": "open-spaces-parks-reserves",
      "description": "Improvement works to the Garden of Remembrance at the Wainuiomata Cemetery, enhancing this space for those who wish to remember and reflect. Gardens of remembrance are a meaningful space for families. This project improves the amenity, planting, and presentation of the garden.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 44150,
        "2029/2030": 619823,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 48795
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-122",
      "name": "Parks & Reserve Drainage Improvements",
      "category": "open-spaces-parks-reserves",
      "description": "Drainage works across parks and reserves to address waterlogging that affects the usability of sports fields and open spaces. Many of the district's parks suffer from poor drainage, which limits the hours they can be used for sport and recreation. Better drainage protects turf quality and extends the productive use of these assets.",
      "yearlyAmounts": {
        "2025/2026": 1405250,
        "2026/2027": 1796553,
        "2027/2028": 803287,
        "2028/2029": 1071983,
        "2029/2030": 1335874,
        "2030/2031": 1363879,
        "2031/2032": 312157,
        "2032/2033": 476980,
        "2033/2034": 486057
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-123",
      "name": "Parks & Reserves Security Improvements",
      "category": "open-spaces-parks-reserves",
      "description": "Installation of security improvements in parks and reserves, such as lighting, fencing, and cameras, to improve safety for park users and reduce vandalism and damage to assets. Security measures encourage use of parks at a wider range of times and help protect council infrastructure. This project funds targeted security improvements at the highest-need locations.",
      "yearlyAmounts": {
        "2025/2026": 163520,
        "2026/2027": 105062,
        "2027/2028": 107583,
        "2028/2029": 109947,
        "2029/2030": 112258,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-open-spaces-parks-reserves-124",
      "name": "Seats & Bins",
      "category": "open-spaces-parks-reserves",
      "description": "Installation and replacement of park seating and litter bins across the district's open spaces. Seating and bins are fundamental park amenities that improve the visitor experience and support environmental cleanliness. This ongoing programme ensures the park network is well-equipped to meet community expectations.",
      "yearlyAmounts": {
        "2025/2026": 68474,
        "2026/2027": 72351,
        "2027/2028": 76235,
        "2028/2029": 79008,
        "2029/2030": 82910,
        "2030/2031": 85792,
        "2031/2032": 90014,
        "2032/2033": 93808,
        "2033/2034": 97629
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-125",
      "name": "Parks Buildings Capital Renewals",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of park buildings across the network, including pavilions, changing rooms, maintenance sheds, and public shelters. Park buildings support sports clubs, events, and park visitors. Renewal investment addresses condition issues and extends the life of these important community assets.",
      "yearlyAmounts": {
        "2025/2026": 1207462,
        "2026/2027": 326880,
        "2027/2028": 670450,
        "2028/2029": 1027727,
        "2029/2030": 137241,
        "2030/2031": 182856,
        "2031/2032": 604397,
        "2032/2033": 1570387,
        "2033/2034": 844536
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-126",
      "name": "Avalon Park Pavilion Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of the pavilion at Avalon Park to address building condition issues and extend the facility's operational life. The pavilion is used by sports clubs and for community events in one of Lower Hutt's major parks. Renewal ensures it remains a functional and welcoming facility for users.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 123721,
        "2028/2029": 0,
        "2029/2030": 107768,
        "2030/2031": 0,
        "2031/2032": 72486,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-127",
      "name": "Parks Hard Surfaces Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of hard surface areas in parks and reserves, including car parks, pathways, court surfaces, and other paved areas. Hard surfaces deteriorate with use and weather exposure, and renewal is necessary to maintain safety and accessibility. This programme is prioritised based on condition assessments across the parks network.",
      "yearlyAmounts": {
        "2025/2026": 1296294,
        "2026/2027": 228831,
        "2027/2028": 1001598,
        "2028/2029": 1054391,
        "2029/2030": 658956,
        "2030/2031": 1165601,
        "2031/2032": 898888,
        "2032/2033": 1286653,
        "2033/2034": 438666
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-128",
      "name": "Playgrounds",
      "category": "open-spaces-parks-reserves",
      "description": "Annual programme of playground equipment renewal and installation across the district's parks and reserves. Playground equipment has a defined serviceable life and must be replaced or refurbished when it becomes worn or fails safety standards. This programme ensures children across the district have access to safe, modern play equipment.",
      "yearlyAmounts": {
        "2025/2026": 235060,
        "2026/2027": 247945,
        "2027/2028": 259275,
        "2028/2029": 271569,
        "2029/2030": 282891,
        "2030/2031": 293406,
        "2031/2032": 307146,
        "2032/2033": 319832,
        "2033/2034": 332602
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-129",
      "name": "Petone Wharf",
      "category": "open-spaces-parks-reserves",
      "description": "Petone Wharf has been closed to the public since 18 January 2021, when earthquakes over New Year 2020/21 caused several piles to fail and severe slumping in the deck. The wharf opened in 1908 and is a much-loved community asset on the Petone foreshore. Approximately $12 million has been budgeted to replace as much of the structure as possible, with the bulk of the spending planned for 2026/27.",
      "yearlyAmounts": {
        "2025/2026": 2287625,
        "2026/2027": 9420000,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-130",
      "name": "Track Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of walking and recreational tracks across the district's reserves and hill country. Tracks deteriorate over time from foot traffic, weather, and root damage, requiring periodic renewal to maintain safety and accessibility. This programme funds targeted renewal of tracks that have reached the end of their serviceable life.",
      "yearlyAmounts": {
        "2025/2026": 251464,
        "2026/2027": 120821,
        "2027/2028": 126948,
        "2028/2029": 131936,
        "2029/2030": 138078,
        "2030/2031": 143265,
        "2031/2032": 149815,
        "2032/2033": 155998,
        "2033/2034": 162222
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-131",
      "name": "Parks Signage & Interpretation",
      "category": "open-spaces-parks-reserves",
      "description": "Installation of new signage and interpretation panels in parks and reserves to improve wayfinding and help visitors understand the natural and cultural heritage of these spaces. Good signage enhances the visitor experience and helps people navigate the district's recreational network. Interpretation panels add educational and cultural value to park visits.",
      "yearlyAmounts": {
        "2025/2026": 65408,
        "2026/2027": 36772,
        "2027/2028": 69929,
        "2028/2029": 39581,
        "2029/2030": 41536,
        "2030/2031": 42406,
        "2031/2032": 44427,
        "2032/2033": 46122,
        "2033/2034": 47825
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-132",
      "name": "Playgrounds",
      "category": "open-spaces-parks-reserves",
      "description": "Major playground renewal or installation at a specific park location, providing new or significantly upgraded play equipment for local children and families. This is a larger one-off investment compared to the annual playground renewal programme, delivering a flagship or substantially upgraded playground destination for the community.",
      "yearlyAmounts": {
        "2025/2026": 925754,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-133",
      "name": "Korohiwa Bus Barn Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of the Korohiwa Bus Barn, a historic building in the council's parks and reserves portfolio in Eastbourne. The structure requires periodic renewal to maintain its structural integrity. Renewal works address building condition issues to ensure the asset remains safe and functional.",
      "yearlyAmounts": {
        "2025/2026": 29005,
        "2026/2027": 52892,
        "2027/2028": 87762,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-134",
      "name": "Hutt Rec Artificial Turf Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Replacement of the artificial turf surface at Hutt Recreation Ground (Hutt Rec), one of Lower Hutt's premier multi-sport venues. Artificial turf has a lifespan of approximately 10 to 12 years and requires replacement when the pile height and infill degrade below safe and functional levels. Renewal maintains the venue as a high-quality playing surface for multiple sports codes.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 494882,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-135",
      "name": "Hutt Rec Sand Carpet Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of the sand carpet surface at Hutt Recreation Ground, used for hockey and other sports. Sand carpet surfaces require renewal when they degrade and can no longer provide adequate performance and safety for players. This project maintains Hutt Rec's reputation as a quality multi-sport destination.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 617002,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-136",
      "name": "Petone Grandstand Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of the grandstand at Petone Recreation Ground to address structural and building condition issues. The Petone grandstand is a heritage structure and an important part of Petone's sporting and cultural landscape. Renewal works ensure it remains safe for spectators and reflects the significance of sport in Petone's history.",
      "yearlyAmounts": {
        "2025/2026": 2550000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-137",
      "name": "Naenae Bowls Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of bowling greens and facilities at the Naenae Bowls Club, supporting this community sport in the Naenae area. Bowls facilities require periodic renewal of greens, surrounds, and associated buildings to maintain playable and safe conditions. This investment supports the ongoing operation of the club and access to the sport for the community.",
      "yearlyAmounts": {
        "2025/2026": 21837,
        "2026/2027": 27874,
        "2027/2028": 301594,
        "2028/2029": 0,
        "2029/2030": 322628,
        "2030/2031": 0,
        "2031/2032": 68701,
        "2032/2033": 0,
        "2033/2034": 29102
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-138",
      "name": "Ricoh Sports Centre Renewal",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal works on the Ricoh Sports Centre, a multi-sport indoor facility in Lower Hutt. The centre hosts a range of indoor sports and community activities. Renewal investment addresses building condition and infrastructure issues to maintain the facility's viability as a key sports destination in the district.",
      "yearlyAmounts": {
        "2025/2026": 78081,
        "2026/2027": 28341,
        "2027/2028": 255377,
        "2028/2029": 0,
        "2029/2030": 72006,
        "2030/2031": 53737,
        "2031/2032": 253818,
        "2032/2033": 0,
        "2033/2034": 44876
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-open-spaces-parks-reserves-139",
      "name": "Parks & Reserves Drainage Renewals",
      "category": "open-spaces-parks-reserves",
      "description": "Renewal of existing drainage infrastructure in parks and reserves that has reached the end of its serviceable life. Unlike the drainage improvements programme which adds capacity, this renewal programme replaces assets that have failed or deteriorated. Functioning drainage is essential for maintaining turf quality and the usability of parks.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 1158110,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-140",
      "name": "Dowse Collection Storage Upgrade",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Upgrade of storage facilities for the Dowse Art Museum's permanent collection, improving conservation conditions for artworks and artefacts. Proper collection storage is a core requirement of museum operation, protecting taonga and artworks from deterioration due to light, humidity, and temperature. This project ensures the Dowse meets the standards expected of a significant regional art museum.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 110375,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 140887,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-141",
      "name": "Dowse New Artworks",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Acquisition of new artworks to expand the permanent collection of the Dowse Art Museum. The Dowse holds a significant regional collection of New Zealand art, particularly contemporary work and taonga Maori. Growing the collection ensures the museum remains relevant and continues to reflect the breadth of New Zealand artistic achievement.",
      "yearlyAmounts": {
        "2025/2026": 55620,
        "2026/2027": 62896,
        "2027/2028": 64405,
        "2028/2029": 71804,
        "2029/2030": 73313,
        "2030/2031": 81087,
        "2031/2032": 82715,
        "2032/2033": 90856,
        "2033/2034": 92585
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-142",
      "name": "Dowse Heat Pump",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Installation of heat pump systems at the Dowse Art Museum for energy-efficient heating and cooling of gallery and storage spaces. Maintaining stable temperature and humidity is critical for the preservation of artworks and museum collections. Heat pumps also reduce operating costs and carbon emissions compared to older systems.",
      "yearlyAmounts": {
        "2025/2026": 900000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-143",
      "name": "Little Theatre Improvements",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Capital works on the Little Theatre in Lower Hutt, covering both ongoing improvements to enhance facilities for performers and audiences, and periodic renewal of the building fabric and technical infrastructure. The Little Theatre is an important community performing arts venue hosting amateur and community theatre productions. Merged from two budget lines: Little Theatre Improvements ($0.10M in 2026/27, Improve Level of Service, 49.4%) and Little Theatre Renewal ($0.11M in 2026/27, Replace Existing Assets, 50.6%). Total 2026/27: $0.21M.",
      "yearlyAmounts": {
        "2025/2026": 122876,
        "2026/2027": 209144,
        "2027/2028": 119414,
        "2028/2029": 2179,
        "2029/2030": 168326,
        "2030/2031": 83448,
        "2031/2032": 249924,
        "2032/2033": 0,
        "2033/2034": 74534
      },
      "projectType": "capex",
      "subcategories": [
        {
          "id": "capex-connectivity-creativity-learning-recreation-143-sub-improve",
          "name": "Little Theatre Improvements",
          "category": "connectivity-creativity-learning-recreation",
          "yearlyAmounts": {
            "2025/2026": 0,
            "2026/2027": 103320,
            "2027/2028": 0,
            "2028/2029": 0,
            "2029/2030": 0,
            "2030/2031": 0,
            "2031/2032": 191624,
            "2032/2033": 0,
            "2033/2034": 0
          },
          "projectType": "capex",
          "subcategoryTag": "improve-level-of-service"
        },
        {
          "id": "capex-connectivity-creativity-learning-recreation-173",
          "name": "Little Theatre Renewal",
          "category": "connectivity-creativity-learning-recreation",
          "description": "Major renewal works on the Little Theatre building to address condition issues and extend the facility's operational life. The Little Theatre is an important community performance venue and requires periodic renewal of building fabric, services, and technical infrastructure. Renewal investment ensures the theatre continues to serve the community for future generations.",
          "yearlyAmounts": {
            "2025/2026": 122876,
            "2026/2027": 105824,
            "2027/2028": 119414,
            "2028/2029": 2179,
            "2029/2030": 168326,
            "2030/2031": 83448,
            "2031/2032": 58300,
            "2032/2033": 0,
            "2033/2034": 74534
          },
          "projectType": "capex",
          "subcategoryTag": "replace-existing-assets"
        }
      ]
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-144",
      "name": "Little Theatre Sound and Lighting Improvements",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Upgrade of the sound and lighting systems at the Little Theatre to improve the quality of performances. Modern lighting and audio equipment significantly enhances the audience experience and expands the range of productions the venue can support. This investment keeps the Little Theatre competitive as a community performing arts destination.",
      "yearlyAmounts": {
        "2025/2026": 66744,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 36799,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 195447,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-145",
      "name": "McKenzie Pool Renewals",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal works at McKenzie Pool in Petone to maintain the facility and extend its operational life. Pool infrastructure requires ongoing renewal of plant, equipment, and building fabric to remain safe and functional. These works ensure the Petone community continues to have access to its local pool.",
      "yearlyAmounts": {
        "2025/2026": 162249,
        "2026/2027": 98789,
        "2027/2028": 167475,
        "2028/2029": 12545,
        "2029/2030": 252722,
        "2030/2031": 46821,
        "2031/2032": 75149,
        "2032/2033": 38898,
        "2033/2034": 86731
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-146",
      "name": "Pools Other Improvement Projects",
      "category": "connectivity-creativity-learning-recreation",
      "description": "A programme of improvement projects across the council's aquatic facilities, covering upgrades that do not fall into specific pool renewal categories. These may include accessibility improvements, changing room upgrades, or facility enhancements requested by users. The programme maintains the council's pools as high-quality community facilities.",
      "yearlyAmounts": {
        "2025/2026": 138495,
        "2026/2027": 0,
        "2027/2028": 145790,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 155315,
        "2031/2032": 158433,
        "2032/2033": 201179,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-147",
      "name": "Naenae Pool & Fitness Rebuild",
      "category": "connectivity-creativity-learning-recreation",
      "description": "The major rebuild of the Naenae Pool and Fitness Centre, a flagship community infrastructure project for the Hutt Valley. The new facility features a 50-metre Olympic standard pool with 10 lanes and two moveable bulkheads, a leisure pool, hydro-slide, and fitness centre — approximately 65% larger than the previous pool. The project, valued at approximately $41 million, replaces the demolished Naenae Pool that opened in the 1960s.",
      "yearlyAmounts": {
        "2025/2026": 1050250,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-148",
      "name": "RFID Robotic Returns Sorter",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Purchase of an RFID-enabled robotic sorting system for council libraries to automate the processing of returned books and other items. Automated sorting systems significantly speed up the processing of returned items and reduce repetitive manual handling for library staff. The technology enables faster return of items to shelves for patron borrowing.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 373760,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 229668,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-149",
      "name": "Libraries Buildings Improvements",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Capital improvements to library buildings across the district to maintain and enhance the quality of the network's physical spaces. Modern libraries serve as community hub spaces as well as book collections, and buildings must support a range of uses. Works may include refurbishments, accessibility improvements, and building fabric upgrades.",
      "yearlyAmounts": {
        "2025/2026": 51100,
        "2026/2027": 52531,
        "2027/2028": 53792,
        "2028/2029": 54973,
        "2029/2030": 112258,
        "2030/2031": 57306,
        "2031/2032": 58456,
        "2032/2033": 59622,
        "2033/2034": 60757
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-150",
      "name": "Civic Events Centre Improvements",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Capital improvements to the Hutt City Civic Events Centre, maintaining and enhancing this venue for events, conferences, and community activities. The centre is a significant civic asset and an important venue for cultural and community events in Lower Hutt. Improvements maintain the building's functionality and presentation as a public facility.",
      "yearlyAmounts": {
        "2025/2026": 99320,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-151",
      "name": "Eastbourne Library/Community Hub Building Improvements",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Improvements to the building housing the Eastbourne Library and Community Hub, which serves the Eastbourne and surrounding communities on the eastern side of Wellington Harbour. The building provides library services and community meeting space. Capital works maintain and improve the building fabric and facilities for these communities.",
      "yearlyAmounts": {
        "2025/2026": 98083,
        "2026/2027": 98463,
        "2027/2028": 26829,
        "2028/2029": 6498,
        "2029/2030": 83651,
        "2030/2031": 727,
        "2031/2032": 18870,
        "2032/2033": 1269,
        "2033/2034": 31963
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-152",
      "name": "Naenae Fitness Suite Equipment Purchase",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Purchase of fitness equipment for the Naenae Pool and Fitness Centre's fitness suite to ensure it is well-equipped on opening. Modern, well-maintained equipment is essential to attract and retain members and provide a quality fitness experience. This investment ensures the fitness suite opens with a full and effective equipment offering.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 183996,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-153",
      "name": "Petone Settlers Museum New Lighting and Furnishings",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Installation of new lighting and furnishings at the Petone Settlers Museum, improving exhibition presentation and visitor experience. Good lighting is critical to museum displays — it enhances artefacts, protects collections from UV damage, and creates an engaging atmosphere. Updated furnishings improve the functionality and aesthetic of the museum's spaces.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 130298,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-154",
      "name": "Wainuiomata Pool Renewals",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal works at the Wainuiomata aquatic facility to maintain pool infrastructure and extend the facility's operational life. Pool facilities require ongoing renewal of plant, pipework, and building systems to meet health and safety standards. This investment ensures Wainuiomata residents continue to have access to their local pool.",
      "yearlyAmounts": {
        "2025/2026": 297977,
        "2026/2027": 360921,
        "2027/2028": 66327,
        "2028/2029": 474261,
        "2029/2030": 117549,
        "2030/2031": 148330,
        "2031/2032": 35159028,
        "2032/2033": 23828,
        "2033/2034": 142252
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-155",
      "name": "Self Scanning Machines Purchase",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Purchase of self-checkout scanning machines for council libraries, allowing patrons to check out items without staff assistance. Self-service machines improve patron convenience, reduce wait times, and allow library staff to focus on higher-value customer interactions. Self-checkout technology is now standard practice in modern public libraries.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 281738,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-156",
      "name": "Stokes Valley Pool Heat Pump",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Installation of heat pump technology at Stokes Valley Pool to provide energy-efficient water and space heating. Pool heating is a major operational cost, and heat pumps offer significant energy savings compared to gas boilers. This project reduces the pool's carbon footprint and lowers ongoing operating costs.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 612783,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-157",
      "name": "Decarbonisation Energy Conversion (Huia Pool)",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Conversion of Huia Pool's energy systems from gas to electric alternatives, reducing the facility's carbon emissions. Huia Pool is a significant energy user, and switching to lower-carbon heating technology aligns with the council's emissions reduction targets. The conversion also reduces the facility's exposure to gas price fluctuations.",
      "yearlyAmounts": {
        "2025/2026": 3884000,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-158",
      "name": "Decarbonisation Energy Conversion (Libraries)",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Conversion of energy systems in council library buildings from gas to lower-carbon electric alternatives as part of the council's decarbonisation programme. Libraries are occupied buildings with ongoing heating needs, making them suitable candidates for electrification. The conversion reduces emissions and operating costs across the library network.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 389806,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-159",
      "name": "War Memorial Library Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the War Memorial Library building in central Lower Hutt, addressing building condition issues and extending the asset's useful life. The War Memorial Library is a heritage building and a key community facility serving the central Hutt Valley. Renewal works maintain the building fabric and ensure it continues to serve the community as a library and memorial space.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 3146,
        "2027/2028": 160862,
        "2028/2029": 3292,
        "2029/2030": 7387,
        "2030/2031": 3432,
        "2031/2032": 0,
        "2032/2033": 1137364,
        "2033/2034": 5817
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-160",
      "name": "Dowse Carpets and Soft Furnishings Gallery and Office",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of carpets and soft furnishings in the Dowse Art Museum's gallery and office spaces. Regular replacement of floor coverings is part of maintaining a professional and welcoming museum environment. This project renews worn finishes to maintain the quality of the Dowse's visitor experience.",
      "yearlyAmounts": {
        "2025/2026": 46304,
        "2026/2027": 25000,
        "2027/2028": 35130,
        "2028/2029": 32984,
        "2029/2030": 86237,
        "2030/2031": 0,
        "2031/2032": 76353,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-161",
      "name": "Dowse Office Furniture and Equipment",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of furniture and equipment in the operational areas of the Dowse Art Museum. Maintaining functional office environments supports staff effectiveness. This project funds the periodic replacement of aged or worn furniture and equipment in the museum's non-public spaces.",
      "yearlyAmounts": {
        "2025/2026": 27810,
        "2026/2027": 27316,
        "2027/2028": 53998,
        "2028/2029": 0,
        "2029/2030": 73313,
        "2030/2031": 45845,
        "2031/2032": 80490,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-162",
      "name": "Dowse Museum Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Major renewal works on the Dowse Art Museum building and facilities to extend the asset's life and maintain it as a high-quality regional art institution. The Dowse is a significant cultural asset for the Hutt Valley and Greater Wellington. Renewal investment addresses building fabric, services, and infrastructure to ensure the museum meets the expectations of its collections and visitors.",
      "yearlyAmounts": {
        "2025/2026": 355724,
        "2026/2027": 312451,
        "2027/2028": 160783,
        "2028/2029": 7904,
        "2029/2030": 323214,
        "2030/2031": 426574,
        "2031/2032": 63565,
        "2032/2033": 11924,
        "2033/2034": 170808
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-163",
      "name": "Dowse Gallery Lighting",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Upgrade of lighting systems throughout the Dowse Art Museum's gallery spaces. High-quality, controllable gallery lighting is essential for presenting artworks effectively and safely. Modern LED gallery lighting systems reduce UV exposure to sensitive works, allow precise colour temperature control, and reduce energy consumption.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 68880,
        "2027/2028": 0,
        "2028/2029": 84097,
        "2029/2030": 0,
        "2030/2031": 112712,
        "2031/2032": 0,
        "2032/2033": 104238,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-164",
      "name": "Petone Settlers Museum Building & Plant Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the building fabric and mechanical plant at the Petone Settlers Museum, which houses a significant collection relating to the history of early settlement in New Zealand and the Hutt Valley. The museum building requires periodic renewal to protect the collections and provide a quality visitor experience. This investment ensures the museum remains a viable heritage facility for the long term.",
      "yearlyAmounts": {
        "2025/2026": 12480,
        "2026/2027": 52228,
        "2027/2028": 59582,
        "2028/2029": 0,
        "2029/2030": 246859,
        "2030/2031": 9781,
        "2031/2032": 26640,
        "2032/2033": 0,
        "2033/2034": 19378
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-165",
      "name": "Other Pool Projects",
      "category": "connectivity-creativity-learning-recreation",
      "description": "A programme for capital pool projects that do not fall under specific named pool renewal or improvement categories. These may include minor facility upgrades, equipment purchases, or responsive works identified during the year. The programme ensures small but important pool improvements can be carried out without requiring separate project approvals.",
      "yearlyAmounts": {
        "2025/2026": 1350000,
        "2026/2027": 0,
        "2027/2028": 257473,
        "2028/2029": 109890,
        "2029/2030": 385475,
        "2030/2031": 147111,
        "2031/2032": 194358,
        "2032/2033": 107951,
        "2033/2034": 246411
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-166",
      "name": "Huia Pool Fitness Suite Equipment Replacement",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of fitness equipment at the Huia Pool fitness suite. Fitness equipment has a finite lifespan and must be periodically replaced to maintain a safe and attractive facility. Modern equipment improves the user experience and ensures the fitness suite remains competitive.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 299190,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 331622,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-167",
      "name": "Furniture and Equipment Replacement Programme Libraries",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Ongoing programme replacing furniture and equipment across the council's library network. Library furniture and equipment receives heavy use and requires systematic replacement to maintain a comfortable and functional environment for patrons. The programme ensures libraries remain inviting and well-equipped community spaces.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 408053,
        "2027/2028": 125148,
        "2028/2029": 48468,
        "2029/2030": 67815,
        "2030/2031": 50524,
        "2031/2032": 136001,
        "2032/2033": 52567,
        "2033/2034": 73407
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-168",
      "name": "Replace Library Shelving",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of library shelving systems that have reached the end of their serviceable life or no longer suit the layout and collection needs of the library. Well-maintained, accessible shelving is fundamental to library operations and the patron experience. New shelving may also reflect changes in collection size or library layout strategy.",
      "yearlyAmounts": {
        "2025/2026": 72640,
        "2026/2027": 73114,
        "2027/2028": 161375,
        "2028/2029": 54973,
        "2029/2030": 24697,
        "2030/2031": 25215,
        "2031/2032": 25721,
        "2032/2033": 26234,
        "2033/2034": 26733
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-169",
      "name": "Libraries Stock Replacement",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Annual capital funding for replacement of library collection stock — books, audiovisual materials, and digital resources. Library collections naturally deplete as items are lost, damaged, or become outdated, and regular investment in new stock keeps collections current and relevant. This is an ongoing programme across all library branches.",
      "yearlyAmounts": {
        "2025/2026": 794960,
        "2026/2027": 739151,
        "2027/2028": 637968,
        "2028/2029": 651986,
        "2029/2030": 612930,
        "2030/2031": 625780,
        "2031/2032": 638343,
        "2032/2033": 651077,
        "2033/2034": 663468
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-170",
      "name": "Civic Events Centre Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the Civic Events Centre's building fabric and infrastructure to extend the asset's operational life. As a major public venue, the Events Centre requires periodic renewal of its structural elements, services, and finishes. This investment ensures the building remains safe, functional, and fit to host the range of events and activities it supports.",
      "yearlyAmounts": {
        "2025/2026": 37218,
        "2026/2027": 700000,
        "2027/2028": 409600,
        "2028/2029": 104650,
        "2029/2030": 534250,
        "2030/2031": 327270,
        "2031/2032": 333840,
        "2032/2033": 340500,
        "2033/2034": 346980
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-171",
      "name": "Huia Pool Boiler Replacement, Hydro/LTS Pool",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of the boiler systems serving the hydrotherapy and learn-to-swim pools at Huia Pool. Pool boilers are critical mechanical plant that heat water for swimmers, and ageing systems are prone to failure and inefficiency. Replacement ensures reliable, efficient pool heating and reduces the risk of unplanned facility closures.",
      "yearlyAmounts": {
        "2025/2026": 997826,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-172",
      "name": "Petone Settlers Museum Exhibition Furniture and Fittings",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Replacement of exhibition furniture, display cases, and fittings at the Petone Settlers Museum to refresh and improve the presentation of displays. Quality exhibition infrastructure is important for presenting collections effectively and meeting visitor expectations. This project maintains the museum's ability to deliver engaging and professional exhibitions.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 60069,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 76650,
        "2032/2033": 0,
        "2033/2034": 13278
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-174",
      "name": "Petone Library Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the Petone Library building to address building condition and extend the asset's useful life. Petone Library is a key community facility serving Petone and surrounding communities. Renewal works maintain the building in a condition appropriate for its combined role as a library and community gathering space.",
      "yearlyAmounts": {
        "2025/2026": 3250000,
        "2026/2027": 1500000,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-175",
      "name": "Moera Library Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the Moera Library building to address condition issues and maintain its service to the Moera community. Community libraries are important local facilities, particularly in areas where other services may be less accessible. Renewal investment protects this community asset for continued use.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 8947,
        "2028/2029": 4180,
        "2029/2030": 42352,
        "2030/2031": 3782,
        "2031/2032": 0,
        "2032/2033": 1028,
        "2033/2034": 8258
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-176",
      "name": "Eastbourne Pool Renewals",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal works at the Eastbourne Pool to maintain this community aquatic facility serving the eastern side of Wellington Harbour. The pool is an important asset for the Eastbourne community given its relative isolation from other aquatic facilities. Renewal investment ensures the pool remains safe and operational for local residents.",
      "yearlyAmounts": {
        "2025/2026": 19720,
        "2026/2027": 49725,
        "2027/2028": 75460,
        "2028/2029": 4849,
        "2029/2030": 554282,
        "2030/2031": 0,
        "2031/2032": 50427,
        "2032/2033": 0,
        "2033/2034": 17888
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-177",
      "name": "Stokes Valley Pool Renewals",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of pool infrastructure at Stokes Valley Pool to maintain and extend the facility's operational life. Pool systems including pipework, filtration, and plant require periodic renewal to maintain safe and compliant operations. This investment ensures the Stokes Valley community continues to have access to its local aquatic facility.",
      "yearlyAmounts": {
        "2025/2026": 101005,
        "2026/2027": 1613715,
        "2027/2028": 386408,
        "2028/2029": 123430,
        "2029/2030": 370923,
        "2030/2031": 367190,
        "2031/2032": 122364,
        "2032/2033": 31648,
        "2033/2034": 202073
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-178",
      "name": "Naenae Pool Renewals",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Capital renewal works associated with the Naenae Pool and Fitness Centre, covering ongoing building system and infrastructure maintenance. A facility of this scale and complexity requires sustained investment to remain in top condition after the major rebuild. This ensures the new pool continues to operate at a high standard for the community.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 802050,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-179",
      "name": "Naenae Library Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the Naenae Library building to address building condition and extend the asset's operational life. The Naenae Library serves as a key community facility in this Lower Hutt suburb. Renewal works maintain the building fabric and ensure the library remains a welcoming and functional space for the community.",
      "yearlyAmounts": {
        "2025/2026": 18179,
        "2026/2027": 29285,
        "2027/2028": 107649,
        "2028/2029": 1043,
        "2029/2030": 63531,
        "2030/2031": 57759,
        "2031/2032": 26146,
        "2032/2033": 0,
        "2033/2034": 24374
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-connectivity-creativity-learning-recreation-180",
      "name": "Wainuiomata Library Renewal",
      "category": "connectivity-creativity-learning-recreation",
      "description": "Renewal of the Wainuiomata Library building to maintain the facility and extend its useful life. Libraries are anchor community facilities in suburban areas, providing access to information, learning resources, and community connection. Renewal investment ensures the Wainuiomata Library continues to serve the community effectively.",
      "yearlyAmounts": {
        "2025/2026": 41515,
        "2026/2027": 21686,
        "2027/2028": 223842,
        "2028/2029": 0,
        "2029/2030": 81310,
        "2030/2031": 1140,
        "2031/2032": 85508,
        "2032/2033": 689,
        "2033/2034": 27064
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-181",
      "name": "Other (IT) Projects",
      "category": "corporate-services",
      "description": "A programme for information technology capital projects that do not fall within specific named IT categories. These may include software implementations, system upgrades, or hardware purchases responding to emerging technology needs. The programme provides flexibility to deliver priority IT projects identified during the year.",
      "yearlyAmounts": {
        "2025/2026": 63097,
        "2026/2027": 49599,
        "2027/2028": 854159,
        "2028/2029": 820753,
        "2029/2030": 886727,
        "2030/2031": 785044,
        "2031/2032": 936532,
        "2032/2033": 517215,
        "2033/2034": 959840
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-corporate-services-182",
      "name": "Facilities Seismic Strengthening",
      "category": "corporate-services",
      "description": "Structural works to improve the earthquake resilience of council-owned buildings across the district. Buildings identified as earthquake-prone under the Building Act require strengthening to reduce risk to occupants and the public. This programme funds seismic assessments and strengthening works to bring facilities up to required standards.",
      "yearlyAmounts": {
        "2025/2026": 1771527,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-corporate-services-183",
      "name": "Vehicle Purchase",
      "category": "corporate-services",
      "description": "Purchase of vehicles for council operational use, including fleet renewals and additions across service areas. Council vehicles support services from parks maintenance to building inspections. Regular fleet renewal ensures operational teams have reliable, efficient vehicles that meet current safety and emissions standards.",
      "yearlyAmounts": {
        "2025/2026": 1250694,
        "2026/2027": 792229,
        "2027/2028": 1040588,
        "2028/2029": 945514,
        "2029/2030": 875620,
        "2030/2031": 1456679,
        "2031/2032": 946352,
        "2032/2033": 1010354,
        "2033/2034": 1455100
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-corporate-services-184",
      "name": "IT CCTV",
      "category": "corporate-services",
      "description": "Capital investment in CCTV infrastructure managed through the council's IT team, including cameras, recording systems, and network connectivity for council buildings. Upgrading CCTV technology improves image quality and system reliability. This investment supports the security of council facilities and the safety of staff and visitors.",
      "yearlyAmounts": {
        "2025/2026": 204400,
        "2026/2027": 210123,
        "2027/2028": 215166,
        "2028/2029": 219894,
        "2029/2030": 224517,
        "2030/2031": 229223,
        "2031/2032": 233825,
        "2032/2033": 238490,
        "2033/2034": 243028
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-corporate-services-185",
      "name": "The Pavilion Improvements",
      "category": "corporate-services",
      "description": "Capital improvements to the Pavilion, a council-owned facility used for events and community activities. The Pavilion is available for hire by community groups and organisations. Improvements maintain the facility in a fit-for-purpose condition and enhance its appeal as an event venue.",
      "yearlyAmounts": {
        "2025/2026": 144613,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 108124,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "capex",
      "subcategoryTag": "improve-level-of-service"
    },
    {
      "id": "capex-corporate-services-186",
      "name": "Pavilion Renewal",
      "category": "corporate-services",
      "description": "Structural and building fabric renewal of the Pavilion to address condition issues and extend the asset's operational life. Like other council facilities, the Pavilion requires periodic renewal of its building systems and fabric. This investment ensures the venue remains safe, functional, and available for community use.",
      "yearlyAmounts": {
        "2025/2026": 45139,
        "2026/2027": 27290,
        "2027/2028": 211573,
        "2028/2029": 801,
        "2029/2030": 210595,
        "2030/2031": 4615,
        "2031/2032": 1173955,
        "2032/2033": 0,
        "2033/2034": 36790
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-187",
      "name": "Civic Administration Building Renewal",
      "category": "corporate-services",
      "description": "Renewal works on the Civic Administration Building at 30 Laings Road, Lower Hutt, the council's main office and public-facing service centre. The building houses council offices, the council chambers, and customer service facilities. Renewal investment maintains the building in a condition appropriate for its role as the centre of local government administration in the Hutt Valley.",
      "yearlyAmounts": {
        "2025/2026": 73584,
        "2026/2027": 124814,
        "2027/2028": 273557,
        "2028/2029": 52700,
        "2029/2030": 272256,
        "2030/2031": 160350,
        "2031/2032": 162867,
        "2032/2033": 311319,
        "2033/2034": 156818
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-188",
      "name": "Aerial Photography",
      "category": "corporate-services",
      "description": "Periodic aerial photography of the Hutt City district for mapping, planning, and asset management purposes. Up-to-date aerial imagery is essential for district planning, infrastructure management, and monitoring of development activity. This project funds the capture and processing of high-resolution imagery across the district on a regular cycle.",
      "yearlyAmounts": {
        "2025/2026": 61320,
        "2026/2027": 0,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 135234,
        "2030/2031": 69035,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 146384
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-189",
      "name": "Hardware – IT Infrastructure",
      "category": "corporate-services",
      "description": "Purchase of server hardware, networking equipment, and other core IT infrastructure to maintain the council's technology systems. IT infrastructure has a finite lifespan and requires regular renewal to maintain performance, security, and reliability. This programme ensures the council's digital systems remain current and capable of supporting service delivery.",
      "yearlyAmounts": {
        "2025/2026": 562100,
        "2026/2027": 525259,
        "2027/2028": 563200,
        "2028/2029": 732550,
        "2029/2030": 587675,
        "2030/2031": 599995,
        "2031/2032": 612040,
        "2032/2033": 624250,
        "2033/2034": 636130
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-190",
      "name": "Contingent Facilities Management Fund",
      "category": "corporate-services",
      "description": "A reserve fund for urgent or unforeseen capital works in council facilities that cannot be anticipated in advance. Buildings occasionally require emergency repairs or urgent replacements that fall outside the planned renewals programme. This contingency fund allows the council to respond quickly without requiring separate budget approvals for each unforeseen item.",
      "yearlyAmounts": {
        "2025/2026": 734264,
        "2026/2027": 754823,
        "2027/2028": 772939,
        "2028/2029": 789922,
        "2029/2030": 806529,
        "2030/2031": 823437,
        "2031/2032": 839967,
        "2032/2033": 856724,
        "2033/2034": 873028
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-191",
      "name": "Defibrillators",
      "category": "corporate-services",
      "description": "Purchase and installation of automated external defibrillators (AEDs) in council facilities across the district. AEDs are life-saving devices that can significantly improve survival rates for cardiac arrest victims when used before emergency services arrive. Having AEDs in accessible public locations is an important community health and safety investment.",
      "yearlyAmounts": {
        "2025/2026": 11544,
        "2026/2027": 23733,
        "2027/2028": 12152,
        "2028/2029": 12419,
        "2029/2030": 25359,
        "2030/2031": 12945,
        "2031/2032": 13205,
        "2032/2033": 26937,
        "2033/2034": 40504
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "capex-corporate-services-192",
      "name": "Petone Clock Tower Renewal",
      "category": "corporate-services",
      "description": "Renewal of the Petone Clock Tower, a heritage landmark on Jackson Street in Petone. The clock tower is a beloved local icon and an important part of Petone's heritage streetscape. Renewal works address structural and cosmetic condition issues to maintain the tower as a community landmark for future generations.",
      "yearlyAmounts": {
        "2025/2026": 2510,
        "2026/2027": 1926,
        "2027/2028": 0,
        "2028/2029": 924,
        "2029/2030": 12275,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 597
      },
      "projectType": "capex",
      "subcategoryTag": "replace-existing-assets"
    },
    {
      "id": "opex-sustainability-resilience-001",
      "name": "Waste Minimisation Projects",
      "category": "sustainability-resilience",
      "description": "Annual operating funding for projects that reduce waste generation and encourage diversion from landfill across the Hutt City district. This includes public education, community-led initiatives, and programmes targeting significant waste streams. The projects align with the council's waste management strategy and contribute to national waste minimisation goals. This programme is funded through the waste levy paid to the council by the Government, collected at the Silverstream Landfill.",
      "yearlyAmounts": {
        "2025/2026": 1432801,
        "2026/2027": 1472919,
        "2027/2028": 1508269,
        "2028/2029": 1541410,
        "2029/2030": 1573814,
        "2030/2031": 1606808,
        "2031/2032": 1639065,
        "2032/2033": 1671763,
        "2033/2034": 1703578
      },
      "projectType": "opex"
    },
    {
      "id": "opex-city-development-002",
      "name": "Development Stimulus Package",
      "category": "city-development",
      "description": "Operating funding allocated to support and stimulate development activity across the district, particularly in areas identified for growth and intensification. This may include developer incentives, funding for feasibility studies, or enabling activities that unlock development capacity. The package supports the council's housing and economic development objectives.",
      "yearlyAmounts": {
        "2025/2026": 2847000,
        "2026/2027": 2800048,
        "2027/2028": 177914,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "opex"
    },
    {
      "id": "opex-corporate-services-003",
      "name": "Go Digital Program",
      "category": "corporate-services",
      "description": "Operating investment in the council's Go Digital programme, which aims to improve digital service delivery and accessibility for residents. The programme supports initiatives including online service development, digital literacy, and connectivity improvements for communities at risk of digital exclusion. It aligns with the council's commitment to modernising how residents interact with local government.",
      "yearlyAmounts": {
        "2025/2026": 3531357,
        "2026/2027": 1941582,
        "2027/2028": 434654,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "opex"
    },
    {
      "id": "opex-corporate-services-004",
      "name": "Target Operating Model",
      "category": "corporate-services",
      "description": "Operating investment associated with the council's Target Operating Model (TOM) review, which examined organisational structure and service delivery to identify efficiencies and improvements. The TOM process considered whether current structures best support the delivery of services to the community. This investment supports the implementation of improvements arising from the review.",
      "yearlyAmounts": {
        "2025/2026": 0,
        "2026/2027": 2000000,
        "2027/2028": 0,
        "2028/2029": 0,
        "2029/2030": 0,
        "2030/2031": 0,
        "2031/2032": 0,
        "2032/2033": 0,
        "2033/2034": 0
      },
      "projectType": "opex"
    }
  ],
  "yearlyTotals": [
    {
      "year": "2025/2026",
      "totalAmount": 252624751,
      "categories": {
        "water-supply": 25274748,
        "wastewater": 92643506,
        "stormwater": 10452474,
        "solid-waste": 15912572,
        "sustainability-resilience": 1688801,
        "transport": 50462661,
        "city-development": 16535666,
        "community-partnering-support": 1241000,
        "open-spaces-parks-reserves": 15905079,
        "connectivity-creativity-learning-recreation": 14052095,
        "corporate-services": 8456149
      }
    },
    {
      "year": "2026/2027",
      "totalAmount": 96485797,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 9413373,
        "sustainability-resilience": 1472919,
        "transport": 36115249,
        "city-development": 18676706,
        "community-partnering-support": 1113970,
        "open-spaces-parks-reserves": 16345902,
        "connectivity-creativity-learning-recreation": 6896300,
        "corporate-services": 6451378
      }
    },
    {
      "year": "2027/2028",
      "totalAmount": 109236444,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 16032382,
        "sustainability-resilience": 1508269,
        "transport": 33474432,
        "city-development": 32673138,
        "community-partnering-support": 1987215,
        "open-spaces-parks-reserves": 14389030,
        "connectivity-creativity-learning-recreation": 4793990,
        "corporate-services": 4377988
      }
    },
    {
      "year": "2028/2029",
      "totalAmount": 110583392,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 13493599,
        "sustainability-resilience": 1541410,
        "transport": 43834972,
        "city-development": 31862168,
        "community-partnering-support": 560043,
        "open-spaces-parks-reserves": 13583149,
        "connectivity-creativity-learning-recreation": 2024450,
        "corporate-services": 3683601
      }
    },
    {
      "year": "2029/2030",
      "totalAmount": 113736612,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 4477405,
        "sustainability-resilience": 1573814,
        "transport": 42000337,
        "city-development": 40132923,
        "community-partnering-support": 3642034,
        "open-spaces-parks-reserves": 13088385,
        "connectivity-creativity-learning-recreation": 4784927,
        "corporate-services": 4036787
      }
    },
    {
      "year": "2030/2031",
      "totalAmount": 93212937,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 5753551,
        "sustainability-resilience": 1606808,
        "transport": 35676598,
        "city-development": 35508926,
        "community-partnering-support": 844708,
        "open-spaces-parks-reserves": 6674206,
        "connectivity-creativity-learning-recreation": 3006817,
        "corporate-services": 4141323
      }
    },
    {
      "year": "2031/2032",
      "totalAmount": 105801196,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 6983874,
        "sustainability-resilience": 1639065,
        "transport": 29231409,
        "city-development": 16923703,
        "community-partnering-support": 1104766,
        "open-spaces-parks-reserves": 7260655,
        "connectivity-creativity-learning-recreation": 37738981,
        "corporate-services": 4918743
      }
    },
    {
      "year": "2032/2033",
      "totalAmount": 45097687,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 641579,
        "sustainability-resilience": 1671763,
        "transport": 29684153,
        "city-development": 259586,
        "community-partnering-support": 83998,
        "open-spaces-parks-reserves": 4690143,
        "connectivity-creativity-learning-recreation": 4481176,
        "corporate-services": 3585289
      }
    },
    {
      "year": "2033/2034",
      "totalAmount": 44407055,
      "categories": {
        "water-supply": 0,
        "wastewater": 0,
        "stormwater": 0,
        "solid-waste": 776169,
        "sustainability-resilience": 1703578,
        "transport": 30351309,
        "city-development": 264526,
        "community-partnering-support": 742711,
        "open-spaces-parks-reserves": 3685784,
        "connectivity-creativity-learning-recreation": 2334759,
        "corporate-services": 4548219
      }
    }
  ]
};

export default dap27Data;
